import * as React from 'react';
import { Container } from '@grandvisionhq/elements';

const ErrorPageContainer = ({ children  })=>/*#__PURE__*/ React.createElement(Container, {
        className: "error-layout error-layout-test"
    }, children)
;

export { ErrorPageContainer };
//# sourceMappingURL=ErrorPageContainer.js.map
